import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'ngcKeysStringsArray'})
export class KeysStringsArrayPipe implements PipeTransform {
    transform(value, args: string[]): any {
        const keys = [];
        for (const key of Object.keys(value)) {
            if ( value.hasOwnProperty(key) ) {
                keys.push(key);
            }
        }
        return keys;
    }
}
